import { MessagingChannel } from 'jschannel';
import { CheckResult, StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';

export async function sendQualifiedStatement(
    channel: MessagingChannel,
    contentId: string,
    resultType: CheckResult,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/qualify`,
                display: {
                    und: 'qualified'
                }
            },
            object: {
                id: `${contentId}/pre-check`
            },
            result: {
                type: resultType
            }
        }
    ]);
}